import { render, staticRenderFns } from "./QuickReservation.vue?vue&type=template&id=2bc30496"
import script from "./QuickReservation.vue?vue&type=script&lang=js"
export * from "./QuickReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports